import { render, staticRenderFns } from "./GoOutDetail.vue?vue&type=template&id=513a8476&"
import script from "./GoOutDetail.vue?vue&type=script&lang=js&"
export * from "./GoOutDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoOutDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports